import { render, staticRenderFns } from "./ModattaSideModalFilterOffers.vue?vue&type=template&id=50d173ce"
import script from "./ModattaSideModalFilterOffers.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalFilterOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports